import { Box, styled } from '@mui/material';

const ButtonWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: flex-end;

  margin-top: 16px;
`;

export default ButtonWrapper;
